import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/resenas/star-hand.gif")